import React from "react";
import {
  Section,
  Image,
  Headline,
  Paragraph,
  Box,
  Heading,
  Label,
} from "grommet";

import sentinels from "./sentinels.gif";
import prototype from "./prototype.gif";

const PowerGripDragoons = (props) => (
  <Section colorIndex={props.colorIndex} pad="medium" align="center">
    {!props.responsive ? (
      <Heading tag="h2" strong={true} margin="small">
        Power Grip Dragoons
      </Heading>
    ) : null}
    <Box direction="row" size={{ width: "xxlarge" }}>
      <Box direction="column" basis="2/3" margin="small" textAlign="left">
        <br />
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/5Xk7cDXS-10"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <Paragraph>
          Power Grip Dragoons is a simulation game for Virtual Reality allowing
          the player to pilot mechs: large heavily armed walking robots. It's
          developed in Unity and runs on most VR platforms, including the Oculus
          Quest. I'm a big fan of mechas from various anime, movies and games,
          and I always imagined what it would be like to pilot one. I work on
          this game when I can in my spare time.
        </Paragraph>
        <Paragraph>
          The sim has complex interactions, allowing the pilot to move the legs
          and the torso independently, and also take full control of the mechs
          arms. Additionally the cockpit has many buttons, levers and screens
          that can be interacted with. Designing intuitive controls for all
          these interactions has been a fascinating challenge.
        </Paragraph>
        <Paragraph>
          <Image src={prototype} size="large"></Image>
          <br></br>
          <Label size="small">First Prototype</Label>
        </Paragraph>
      </Box>
      <Box direction="column" basis="1/3" justify="left" textAlign="left">
        <Paragraph>
          The initial idea was to take advantage of VRs 6-dof controllers to
          allow full control over the mechs arms. A visual proxy of each arm was
          rendered in the cockpit. The player can take control of either proxy
          and set the hands position and orientation. Inverse kinematics
          calculate the rotation of the elbow and shoulder. Motors in the actual
          arms then try to match the proxy.
        </Paragraph>
        <Image src={sentinels} size="medium"></Image>
        <Paragraph>A playable demo will soon be made available.</Paragraph>
      </Box>
    </Box>
  </Section>
);

export default PowerGripDragoons;



// WEBPACK FOOTER //
// ./src/components/projects/power-grip-dragoons/power-grip-dragoons.js